// @ts-nocheck
import { apiRequest } from "../../services/apiService";
import { ALERT_DIALOG, UPDATE_USER_DATA } from "../constants/auth";
import {
  CREATE_CLIENT_FAILURE,
  CREATE_CLIENT_REQUEST,
  CREATE_CLIENT_SUCCESS,
  DELETE_CLIENT_FAILURE,
  DELETE_CLIENT_REQUEST,
  DELETE_CLIENT_SUCCESS,
  FETCH_ALL_CLIENTS_FAILURE,
  FETCH_ALL_CLIENTS_REQUEST,
  FETCH_ALL_CLIENTS_SUCCESS,
  SEARCH_CLIENTS_REQUEST,
  SEARCH_CLIENTS_SUCCESS,
  TOGGLE_CLIENT_STATUS_FAILURE,
  TOGGLE_CLIENT_STATUS_REQUEST,
  TOGGLE_CLIENT_STATUS_SUCCESS,
  UPDATE_CLIENT_FAILURE,
  UPDATE_CLIENT_REQUEST,
  UPDATE_CLIENT_SUCCESS,
  APPROVE_CLIENT_TOGGLE_REQUEST,
  APPROVE_CLIENT_TOGGLE_SUCCESS,
  APPROVE_CLIENT_TOGGLE_FAILURE,
  FETCH_ALL_COMPANIES_FAILURE,
  FETCH_ALL_COMPANIES_REQUEST,
  FETCH_ALL_COMPANIES_SUCCESS,
  FETCH_ALL_ACTIVE_CLIENTS_REQUEST,
} from "../constants/client";
import { store } from "../store";
import { alertDialogAciton } from "./auth";

export const fetchAllClientsAction = ({ payload, params, successCallback }) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_ALL_CLIENTS_REQUEST, payload: params?.search });
    const { response, error } = await apiRequest({
      method: "GET",
      // url: `getAllClients?page=${payload?.page}`,
      url: `getAllClients`,
      data: null,
      params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: FETCH_ALL_CLIENTS_SUCCESS,
        payload: response?.data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_ALL_CLIENTS_FAILURE });
    }
  };
};

export const getAllClientsAction = ({
  payload,
  params,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    // dispatch({ type: FETCH_ALL_CLIENTS_REQUEST, payload: params?.search });
    if (beforeCallback) {
      beforeCallback();
    }

    const { response, error } = await apiRequest({
      method: "GET",
      // url: `getAllClients?page=${payload?.page}`,
      url: `getAllClients`,
      data: null,
      params,
      isToken: true,
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response?.status === 200) {
      // dispatch({
      //   type: FETCH_ALL_CLIENTS_SUCCESS,
      //   payload: response?.data,
      // });
      if (successCallback)
        successCallback({
          response,
        });
    } else if (response?.status !== 200 || error) {
      if (failureCallback) {
        failureCallback({
          error,
        });
      }
      // dispatch({ type: FETCH_ALL_CLIENTS_FAILURE });
    }
  };
};

// create a client
export const createClientAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_CLIENT_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: "addClient",
      data: payload,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: CREATE_CLIENT_SUCCESS, payload: response?.data?.data });
      successCallback();
    } else if (response?.status !== 200 || error) {
      if (error?.response?.data?.canForceAdd) {
        dispatch(
          alertDialogAciton({
            open: true,
            title: "Warning",
            message:
              error?.response?.data?.message ||
              "We have a similar company available.",
            okLabel: "Add Anyway",
            onOk: () => {
              dispatch(
                createClientAction(
                  { ...payload, forceAdd: true },
                  successCallback,
                ),
              );
            },
          }),
        );
        dispatch({ type: CREATE_CLIENT_FAILURE });
        return;
      }
      dispatch({ type: CREATE_CLIENT_FAILURE });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: "Error",
          message: error?.response?.data?.message ?? "Unable to create client",
        },
      });
    }
  };
};

// search clients
export const searchClientsAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: SEARCH_CLIENTS_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: `getAllClients?search=${payload?.searchStr ?? ""}&page=${payload?.page}`,
      data: null,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: SEARCH_CLIENTS_SUCCESS, payload: response?.data });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: SEARCH_CLIENTS_REQUEST });
    }
  };
};

// toggle client status
export const toggleClientStatusAction = (payload) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_CLIENT_STATUS_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: "updateClientIsActive/" + payload.id,
      data: payload?.data,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: TOGGLE_CLIENT_STATUS_SUCCESS,
        payload: response?.data?.data,
      });
    } else if (response?.status !== 200 || error) {
      dispatch({ type: TOGGLE_CLIENT_STATUS_FAILURE });
    }
  };
};

// delete clinet
export const deleteClientAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_CLIENT_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `deleteClient/${payload.id}`,
      data: null,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: DELETE_CLIENT_SUCCESS, payload: payload?.id });
      if (successCallback) {
        successCallback();
      }
    } else if (response?.status !== 200 || error) {
      dispatch({ type: DELETE_CLIENT_FAILURE });
      if (failureCallback) {
        failureCallback({ error });
      }
    }
  };
};

// update clinet
export const updateClientAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_CLIENT_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `updateClient/${payload.id}`,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: UPDATE_CLIENT_SUCCESS, payload: response?.data?.data });
      // if (payload?.isProfile) {
      //   dispatch({
      //     type: UPDATE_USER_DATA,
      //     payload: {
      //       userData: {
      //         ...response?.data?.data,
      //         phoneNumber: response?.data?.data?.mobile,
      //       },
      //     },
      //   });
      // }
      successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_CLIENT_FAILURE });
    }
  };
};

// approve client
export const approveClientAction = (
  params,
  beforeCallback,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: APPROVE_CLIENT_TOGGLE_REQUEST });
    beforeCallback?.();

    const { response, error } = await apiRequest({
      method: "PUT",
      url: "approveClient",
      isToken: true,
      params,
    });

    if (response?.status === 200) {
      dispatch({
        type: APPROVE_CLIENT_TOGGLE_SUCCESS,
        payload: response.data?.data,
      });
      successCallback?.();
    } else {
      dispatch({ type: APPROVE_CLIENT_TOGGLE_FAILURE });
      failureCallback?.(error);
    }
  };
};

// approve multiple licents
export const approveMultipleClientAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: APPROVE_CLIENT_TOGGLE_REQUEST });

    const { response, error } = await apiRequest({
      method: "PUT",
      url: "approveMultipleClient",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: APPROVE_CLIENT_TOGGLE_SUCCESS,
        payload: response.data?.data,
      });
      successCallback?.(response?.data?.message);
    } else {
      dispatch({ type: APPROVE_CLIENT_TOGGLE_FAILURE });
      failureCallback?.(error);
    }
  };
};

// fetch all companies
export const fetchAllCompaniesAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_ALL_COMPANIES_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getCompanies",
      params: {
        ...payload?.params,
        page: 1,
        limit: 20,
      },
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: FETCH_ALL_COMPANIES_SUCCESS });
      if (successCallback) successCallback(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_ALL_COMPANIES_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

// add billing info
export const addBillingInfoToEventAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "addBillingInfo",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      successCallback?.(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

// get client of same business profile
export const getClientsOfSameBusinessAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getCompanyUsers",
      params: payload?.params,
      isToken: true,
    });

    if (response.status == 200) {
      successCallback?.(response?.data);
    } else if (response?.status !== 200 || error) {
      failureCallback?.(error);
      // No global alert — the consumer (CompanyHover) just wants to close the
      // loader silently if it finds no reps. When the caller passes a
      // failureCallback, it decides how to react.
    }
  };
};

/**
 * fetch all active clients
 */
export const fetchAllActiveClientsAction = async ({
  payload,
  successCallback,
  failureCallback,
}) => {
  const { response, error } = await apiRequest({
    method: "GET",
    url: `getActiveClients?search=${payload?.search}`,
    params: { page: 1, limit: 15 },
    data: null,
    isToken: true,
  });

  if (response?.status == 200) {
    successCallback?.(response?.data);
  } else if (response?.status !== 200 || error) {
    failureCallback?.(error?.response?.data?.message);
  }
};